import { render, staticRenderFns } from "./DashboardNotifications.vue?vue&type=template&id=c60b6a94&scoped=true"
import script from "./DashboardNotifications.vue?vue&type=script&lang=js"
export * from "./DashboardNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60b6a94",
  null
  
)

export default component.exports